export default __webpack_public_path__ + "static/media/keyboard_arrow_down_black_24dp.37fca0e1.svg";